/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { NFTOrders, NFTOrdersInterface } from "../NFTOrders";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "zeroExAddress",
        type: "address",
      },
      {
        internalType: "contract IEtherTokenV06",
        name: "weth",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EIP712_DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class NFTOrders__factory {
  static readonly abi = _abi;
  static createInterface(): NFTOrdersInterface {
    return new utils.Interface(_abi) as NFTOrdersInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NFTOrders {
    return new Contract(address, _abi, signerOrProvider) as NFTOrders;
  }
}
